import React, {createContext, ReactNode, useContext, useRef} from "react";
// @ts-ignore
import {Scrollbars} from 'react-custom-scrollbars';

interface TabScrollProps {
    scrollRef: React.RefObject<Scrollbars>;
    scrollTo: (element: Element) => void;
}

const TabScrollContext = createContext<TabScrollProps | null>(null);

export const TabScrollProvider: React.FC<{ children: ReactNode }> = ({children}) => {
    const scrollRef = useRef<Scrollbars>(null);

    const scrollTo = (element: Element) => {
        const targetRect = element.getBoundingClientRect();
        const containerEl = scrollRef.current.view;
        const containerRect = containerEl.getBoundingClientRect();
        const offset = targetRect.top - containerRect.top;
        // containerEl.scrollTop = containerEl.scrollTop + offset;
        scrollRef.current.scrollTop(containerEl.scrollTop + offset);
    }

    return (
        <TabScrollContext.Provider
            value={{
                scrollRef,
                scrollTo
            }}
        >
            {children}
        </TabScrollContext.Provider>
    );
};

export const useTabScroll = (): TabScrollProps => {
    const context = useContext(TabScrollContext);

    if (!context) {
        throw new Error("useTabScroll must be used within a ViewProvider");
    }

    return context;
};